import { Icon } from "../../components/BaseComponents/Icon";

export const HandIcon = (props) => (
	<Icon fill="none" viewBox="0 0 20 20" {...props}>
		<path
			d="M15.3336 12.7902H13.1336C13.2441 13.2339 13.3036 13.689 13.3109 14.1464C13.309 14.324 13.2379 14.4937 13.1131 14.6185C12.9883 14.7434 12.8198 14.8135 12.6443 14.8134H6.66678V13.4646H12.0002C12.0002 12.7492 11.7193 12.063 11.2192 11.5571C10.7191 11.0512 10.0408 10.767 9.33351 10.767H6.66678C5.86676 9.61306 4.20339 9.41815 3.40003 9.41815H2V15.1506L7.46146 17.6885C8.13346 18.028 8.90892 18.0927 9.62685 17.8692L18.0004 15.2633C18.0004 15.2633 17.4724 12.7902 15.3336 12.7902Z"
			fill="url(#paint0_linear_15716_19364)"
		/>
		<path
			d="M12.0001 2C11.209 2 10.4356 2.23732 9.77776 2.68195C9.11995 3.12658 8.60725 3.75856 8.30449 4.49795C8.00173 5.23735 7.92252 6.05096 8.07686 6.83589C8.23121 7.62083 8.61218 8.34184 9.1716 8.90775C9.73103 9.47366 10.4438 9.85905 11.2197 10.0152C11.9957 10.1713 12.7999 10.0912 13.5309 9.78492C14.2618 9.47865 14.8865 8.96 15.3261 8.29457C15.7656 7.62913 16.0002 6.84678 16.0002 6.04647C15.9991 4.97361 15.5774 3.94499 14.8274 3.18637C14.0775 2.42774 13.0607 2.00107 12.0001 2ZM12.6668 8.0697H11.3334V4.02323H12.6668V8.0697Z"
			fill="url(#paint1_linear_15716_19364)"
		/>
		<defs>
			<linearGradient
				id="paint0_linear_15716_19364"
				x1="10.0002"
				y1="9.41815"
				x2="10.0002"
				y2="18"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#0756C0" />
				<stop offset="1" stopColor="#2F97F4" />
			</linearGradient>
			<linearGradient
				id="paint1_linear_15716_19364"
				x1="12.0001"
				y1="2"
				x2="12.0001"
				y2="10.0929"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#0756C0" />
				<stop offset="1" stopColor="#2F97F4" />
			</linearGradient>
		</defs>
	</Icon>
);
